// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IO4qs","warningIcon":"styles_warningIcon__HBX3K","dark":"styles_dark__WfYWb"};